//
// Sources chart
//

'use strict';

var ApexSourcesChart = (function() {

	// Variables

	var $chart = document.querySelector("#apex-sources"),
		$legendItem = $('.legend input'),
		chart;

	var colorPalette = [
		PurposeStyle.colors.theme['primary'],
		PurposeStyle.colors.theme['warning'],
		PurposeStyle.colors.theme['danger'],
		PurposeStyle.colors.theme['success'],
		PurposeStyle.colors.theme['info']
	]

	function init() {
		var options = {
			series: [44, 55, 13, 43, 22],
			chart: {
				// width: 380,
				type: 'pie',
			},
			labels: ['Manual', 'Direct', 'Oblio', 'API', 'Woocomerce'],
			legend: {
			    position: 'bottom',
			    offsetY: 0,
				offsetX: -20,
				horizontalAlign: 'left',
				width: 'auto'
			},
			responsive: [{
				breakpoint: 375,
				options: {
					chart: {
						width: 'auto'
					},
					// legend: {
					// 	position: 'bottom',
					// 	// horizontalAlign: 'center',
    				// 	// floating: false,
					// }
				}
			}]
		};

		// Get data from data attributes
		var height = $chart.dataset.height;

		// Inject synamic properties
		options.colors = colorPalette;

		options.chart.height = height ? height : 350;

		chart = new ApexCharts($chart, options);

		// Draw chart
		setTimeout(function() {
			chart.render();
		}, 300);
	}

	if ($chart) {
		init();
	}

})();
